/**
 * Utilidades para apertura segura de ventanas externas.
 *
 * Skill: security-analysis-checkmarx (CWE-1022 — reverse tabnabbing)
 *
 * `noopener` + `noreferrer` evitan que la página destino acceda a `window.opener`
 * y oculta el header `Referer` (que en GIROP puede llevar parámetros sensibles
 * como `TIPO_DOCUMENTO` / `NUMERO_DOCUMENTO` o el `idCumplimiento`).
 */
export function openExternalWindow(url: string, features = ''): Window | null {
  const flags = ['noopener', 'noreferrer', features]
    .filter(f => f && f.length > 0)
    .join(',');
  const ref = window.open(url, '_blank', flags);
  if (ref) {
    // Defensa adicional: algunos navegadores ignoran `noopener` en features y
    // dejan `opener` accesible. Anularlo explícitamente.
    ref.opener = null;
  }
  return ref;
}
